import React, { Component, useEffect, useState } from "react";
import ComponentInvoiceMobile from "./ComponentInvoiceDetailMobile";
// import ComponentInvoiceWeb from "./ComponentInvoiceWeb";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const ComponentInvoiceDetail = () => {
  const gaEventTracker = useAnalyticsEventTracker("Invoice");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Invoice",
    });
  }, []);
  return (
    <>
      {/* <BrowserView>
        <ComponentInvoiceWeb></ComponentInvoiceWeb>
      </BrowserView> */}
      <MobileView>
        <ComponentInvoiceMobile></ComponentInvoiceMobile>
      </MobileView>
    </>
  );
};
export default ComponentInvoiceDetail;
